import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductsComponent } from './products.component';
import { NbMenuModule } from '@nebular/theme';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { ProductsRoutingModule } from './products-routing.module';
import { ProductComponent } from './product/product.component';





@NgModule({
  declarations: [ProductsComponent, ProductComponent],
  imports: [
    CommonModule,
    ProductsRoutingModule,
    UbsViewContainersModule,
    NbMenuModule
  ],
  exports: [
    ProductsRoutingModule
  ]
})
export class ProductsModule {}
